<h3 id="title" [ngClass]="{title:(this.isFromBankingCenter)}">{{title}}.</h3>
<div [ngClass]="{errorDescriptionContainer:(this.isFromBankingCenter)}">
  <mat-divider></mat-divider>
  <div class="bottom-margin">{{errorDescription}}</div>
  <div class="bottom-margin error-detail" [innerHTML]="errorContactMessage"></div>
  <div class="bottom-margin" hidden>Ref Code - {{refCode}}</div>
  <mat-divider></mat-divider>
</div>
<ng-container *ngIf="!isInAuthenticatedFlow">
  <div fxFlex="100" fxLayoutAlign="end end">
      <button class="secondary-btn-action" mat-stroked-button color="primary" [ngClass]="{button:(this.isFromBankingCenter)}" (click)="navigateTo(closeURL)">CLOSE</button>
  </div>
</ng-container>
